import React from "react";
import {
  Card,
  BlockStack,
  InlineStack,
  Text,
  ProgressBar,
  Button,
  Badge,
  Box,
  Tooltip,
} from "@shopify/polaris";
import { STARTER_PLAN, GROWTH_PLAN, PRO_PLAN } from "../constants";


export function UsageBalanceCard({ processed, planName, onUpgrade, feesCharged = 0, isReadOnly = false }: { processed: number, planName: string, onUpgrade?: () => void, feesCharged?: number, isReadOnly?: boolean }) {
  const limit = planName === STARTER_PLAN ? 10 : planName === GROWTH_PLAN ? 100 : planName === PRO_PLAN ? 1000 : Infinity;

  const progressPercent = Math.min(Math.round((processed / limit) * 100), 100);

  return (
    <Card>
      <BlockStack gap="400">
        <BlockStack gap="200">
          <Tooltip content="Your monthly retention limit is based on your current performance tier. Once reached, AI processing will pause until your next billing cycle.">
            <InlineStack align="space-between">
              <Text as="h2" variant="headingMd">
                {planName === STARTER_PLAN ? "Lifetime Usage" : "Monthly Usage"}
              </Text>
              <Text as="p" variant="bodyMd">
                <span data-testid="usage-count">{processed}</span> / {limit === Infinity ? "Unlimited" : limit.toLocaleString()} Automated Recoveries used
              </Text>
            </InlineStack>
          </Tooltip>

          {limit !== Infinity ? (
            <>
              <ProgressBar progress={progressPercent} size="small" tone={(progressPercent > 90 ? "critical" : progressPercent > 75 ? "attention" : "success") as any} />
              <InlineStack align="space-between" blockAlign="center">
                <Text variant="bodySm" fontWeight="bold" as="span">{progressPercent}%</Text>
                {progressPercent >= 90 && planName !== PRO_PLAN && (
                  <Button size="slim" variant="primary" onClick={onUpgrade} disabled={isReadOnly}>Upgrade Plan</Button>
                )}
              </InlineStack>
            </>
          ) : (
            <Box paddingBlockStart="100">
              <Badge tone="success">Enterprise Plan Active</Badge>
            </Box>
          )}
        </BlockStack>

        <Box paddingBlockStart="200" borderBlockStartWidth="025" borderColor="border-secondary">
          <Tooltip content="Commission-based fee for each order successfully saved by Revivify AI.">
            <InlineStack align="space-between">
              <Text as="h2" variant="headingSm">Performance Fees</Text>
              <div data-testid="performance-fees-amount">
                <Text as="span" variant="bodyMd" fontWeight="bold" tone="success">
                  ${feesCharged.toFixed(2)}
                </Text>
              </div>
            </InlineStack>
          </Tooltip>
        </Box>
      </BlockStack>
    </Card>
  );
}
